<div *ngIf="parentList && !listValues">
    <app-multi-tier-dropdown
        [parentPlaceholder]="parentPlaceholder"
        [childPlaceholder]="childPlaceholder"
        [grandChildPlaceholder]="grandChildPlaceholder"
        [greatGrandChildPlaceholder]="greatGrandChildPlaceholder"
        [parentList]="parentList"
        [formCtrl]="formCtrl"
		[initValue]="initValue"
		(change)="setSelectedValue($event)"></app-multi-tier-dropdown>
</div>
<!-- <div *ngIf="listValues">
    <app-auto-complete-dropdown [placeholder]="placeholder" [listValues]="listValues" [formCtrl]="formCtrl" (change)="setSelectedValue($event)"></app-auto-complete-dropdown>
</div> -->
